// extracted by mini-css-extract-plugin
export default {"form":"LoginPage_form__m8Bii","title":"LoginPage_title__uhZXj","errorMessage":"LoginPage_errorMessage__DGUk1","submit":"LoginPage_submit__OnT4Y"};